import { render, staticRenderFns } from "./PluginManager.vue?vue&type=template&id=402f1daf&"
import script from "./PluginManager.vue?vue&type=script&lang=js&"
export * from "./PluginManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports